import { useState, useEffect } from "react";
import { getAdminInfo } from "../api";
import { User } from "../types/types";

interface UseOwnerAccessReturn {
    user: User | null;
    hasAccess: boolean;
    loading: boolean;
    error: string | null;
}

/**
 * Hook to check if the current user is the company owner.
 * Access is granted only if `user.isOwner` is true.
 */
export const useOwnerAccess = (): UseOwnerAccessReturn => {
    const [user, setUser] = useState<User | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchUser = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                setError("No authentication token found");
                setLoading(false);
                return;
            }

            try {
                const response = await getAdminInfo({ token });
                if (!response) {
                    setError("Failed to fetch user information");
                } else {
                    setUser(response);
                }
            } catch (err) {
                console.error("Error fetching user:", err);
                setError("Failed to fetch user information");
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, []);

    const hasAccess = !!user?.isOwner;

    return {
        user,
        hasAccess,
        loading,
        error,
    };
};
